import { render, staticRenderFns } from "./BoardWriteNewsLayout.vue?vue&type=template&id=28bbde41&scoped=true&"
import script from "./BoardWriteNewsLayout.vue?vue&type=script&lang=js&"
export * from "./BoardWriteNewsLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bbde41",
  null
  
)

export default component.exports